<template>
  <el-dialog
    title="添加审批备注"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    append-to-body
    class="dialog"
    @close="onClose"
    @open="onOpen"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="formDataRule"
      label-suffix="："
      size="small"
      label-width="120px"
      style="width: 100%"
    >
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model.trim="formData.remark"
          type="textarea"
          placeholder="请输入备注"
          maxlength="50"
          :rows="3"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button class="medium-button" size="small" @click="closeDialog">
        取消
      </el-button>
      <el-button
        type="primary"
        class="medium-button"
        size="small"
        @click="confirm"
      >
        确认
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
// 后端api
import { setWorkflowRemarksApi } from '@/api/workflow'

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    workflowId: {
      type: [Number, String],
      required: true,
      default: ''
    },
  },
  data() {
    return {
      formData: {
        remark: ''
      },
      formDataRule: {}
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('change', val)
      }
    },

  },
  methods: {
    onOpen() {
      this.$nextTick(() => {
        this.formData.remark = ''
      })
    },

    async confirm() {
      const valid = await this.$refs.form.validate()
      if (!valid) return

      this.$confirm(`确定提交？`, '提示', {
        type: 'warning'
      }).then(() => {
        setWorkflowRemarksApi({
          workflowId: this.workflowId,
          remark: this.formData.remark
        })
          .then(() => {
            this.$message.success('添加审批备注成功')
            this.closeDialog()
            this.$emit('complete')
          })
          .catch(err => {
            this.$message.error(err.message || '操作失败')
          })
      })
    },

    /**
     * 关闭回调，重置数据
     */
    onClose() {
      this.$refs && this.$refs.form.resetFields()
    },

    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss"></style>
